<template>
  <v-app>
    <v-card flat v-if="modalita == 'form'">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Download Documenti Sicuri
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-5">
        <div style="color: black; font-size: 18px; text-align: center">
          Inserisci le tue credenziali per scaricare il documento.
        </div>
        <form>
          <v-container class="mt-10" fluid>
            <v-row>
              <v-col cols="3"></v-col>
              <v-col cols="6" align="center">
                <v-text-field
                  class="mb-n5"
                  dense
                  label="Username"
                  outlined
                  style="border-radius: 0px; max-width: 300px"
                  v-model="username"
                ></v-text-field>
                <span> (senza prefisso) </span>
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <v-row>
              <v-col cols="3"></v-col>
              <v-col cols="6" align="center">
                <v-text-field
                  class="mt-5"
                  dense
                  label="Password"
                  outlined
                  style="border-radius: 0px; max-width: 300px"
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <v-row>
              <v-col cols="3"></v-col>

              <v-col cols="6" align="center">
                <v-btn @click="login" color="success" dark> Autentica </v-btn>
              </v-col>

              <v-col cols="3"></v-col>
            </v-row>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
    <v-card
      v-else-if="modalita == 'qvsecure'"
      class="ma-0 pa-0"
      height="calc(100vh - 100px)"
      style="overflow: hidden"
    >
      <div style="position: relative; height: 100%">
        <WindowFrame
          ref="windowframe_qvsecure"
          :component="'qvsecure'"
        />
      </div>
    </v-card>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati" absolute z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-app>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "GetSecureDocuments",
  components: {
    SnackbarQV,
    WindowFrame,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    prefisso: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      modalita: "form",
      password: null,
      username: null,
      caricamento_dati: false,
      input_args: {}
      // Modal

      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    loadParamsQVSecure() {
      return true;
    },
    login() {
      this.caricamento_dati = true;
      const request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          username: this.username,
          password: this.password,
          prefisso_utente: this.prefisso,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("user_token", res.data.jwt);
            this.$refs.SnackbarQV.print("success", "Autenticazione riuscita.");
            this.modalita = "qvsecure";
            this.caricamento_dati = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print("error", "Autenticazione non riuscita.");
          this.caricamento_dati = false;
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped></style>
